import { library } from '@fortawesome/fontawesome-svg-core';

import { faComment } from '@fortawesome/pro-light-svg-icons/faComment';
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronDown as falChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { faComments } from '@fortawesome/pro-light-svg-icons/faComments';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons/faEllipsisH';
import { faFlag } from '@fortawesome/pro-light-svg-icons/faFlag';
import { faLanguage } from '@fortawesome/pro-light-svg-icons/faLanguage';
import { faThumbsUp } from '@fortawesome/pro-light-svg-icons/faThumbsUp';
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons/faTrashAlt';
import { faUser } from '@fortawesome/pro-light-svg-icons/faUser';
import { faPencilAlt } from '@fortawesome/pro-light-svg-icons/faPencilAlt';
import { faThumbsUp as faSolidThumbsUp } from '@fortawesome/free-solid-svg-icons/faThumbsUp';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';

/*
 * Adds specified icons to the FontAwesome library
 * so that they can be used by the <Icon /> component
 * in other parts of the app
 */
const setupIcons = () => {
  library.add(
    faComment,
    faComments,
    faEllipsisH,
    faFlag,
    faLanguage,
    faSolidThumbsUp,
    faThumbsUp,
    faTrashAlt,
    faUser,
    faPencilAlt,
    faExclamationTriangle,
    faUsers,
    faChevronDown,
    falChevronDown,
    faComments
  );
};

export default setupIcons;
